define('apps/error-page/views/layout',[
    'common/behaviors/actions'
], function(ActionsBehavior) {
    "use strict";

    return Mn.LayoutView.extend({
        "el": (function() {
            if ($("#de-page-shell").length > 0) {
                return "#de-page-shell";
            }
            return ".comet-page-shell";
        }()),

        "behaviors": {
            "Actions": {
                "behaviorClass": ActionsBehavior
            }
        },
    });
});

